"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const task_1 = require("./task");
/**
 * Represents an awaitable event which can be triggered programmatically.
 */
class AutoResetEvent {
    constructor() {
        this._awaiterCount = 0;
    }
    /**
     * sets the event state to triggered. This will resolve all awaiters with
     * the value true. The event is reset to un-set automatically.
     */
    async set() {
        const awaiter = this._awaiter;
        this._awaiter = undefined;
        await awaiter?.cancel();
    }
    async dispose() {
        await this.set();
    }
    /**
     * Returns a promise which resolves with true when the AutoResetEvent is
     * set to the triggered state or false when the timeout elapses. An
     * optional cancellation token may be provided. When the cancellation token
     * is cancelled, waitOne will resolve with false. While a timeout and a
     * cancellation token may be used in concert, there is no way to know if
     * waitOne resolves with false due to a timeout or cancellation.
     * @param timeoutOrCancellationToken
     * @param cancellationToken
     * @returns
     */
    async waitOne(timeoutOrCancellationToken, cancellationToken) {
        const timeout = typeof timeoutOrCancellationToken === 'number'
            ? timeoutOrCancellationToken
            : 0;
        if (!this._awaiter) {
            this._awaiterCount = 1;
            this._awaiter = new task_1.default(async (cancellationToken) => {
                while (!cancellationToken.isCancellationRequested) {
                    try {
                        await task_1.default.delay(10000, cancellationToken);
                    }
                    catch (e) {
                        //
                    }
                }
            });
        }
        else {
            this._awaiterCount++;
        }
        const realCancellationToken = timeoutOrCancellationToken instanceof _1.CancellationToken
            ? timeoutOrCancellationToken
            : cancellationToken;
        const cts = realCancellationToken ?
            new _1.CancellationTokenSource(realCancellationToken.waitHandle)
            : undefined;
        const promises = [this._awaiter.then(() => true, () => false)];
        if (cts) {
            promises.push(cts.token.waitHandle.then(() => false, () => false));
        }
        if (timeout && timeout > 0) {
            promises.push(task_1.default.delay(timeout, cts?.token).then(() => false, () => false));
        }
        const result = await Promise.race(promises);
        this._awaiterCount--;
        if (this._awaiterCount < 1 && this._awaiter) {
            this.set();
        }
        return result;
    }
}
exports.default = AutoResetEvent;
//# sourceMappingURL=autoResetEvent.js.map